import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmCheckboxComponent } from './sm-checkbox.component';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmCheckboxComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  
  exports: [SmCheckboxComponent]
})
export class SmCheckboxModule { }
